import { Component, ErrorInfo, ReactNode } from 'react';
import i18n from '../app/localization';
import LogoMacRADesignNegative from '../app/images/MacRA-Design_COMPLETE-LOGO-negative.png';
import LogoMaccaferri from '../app/images/LogoMaccaferri.svg';
import Button from '../components/Button/Button';
import './ErrorBoundary.scss';
interface IProps {
    children: ReactNode;
    navigate: any;
}

interface IState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
    public state: IState = {
        hasError: false,
    };

    public static getDerivedStateFromError(_: Error): IState {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // You can also log the error to an error reporting service
        console.error('Uncaught error:', error, errorInfo);
    }

    handleGotoHome = () => {
        this.props.navigate();
        window.location.replace(window.location.origin);
        window.location.reload();
    };

    public render() {
        if (this.state.hasError) {
            const { t } = i18n;
            return (
                <header id='HeaderMacra1'>
                    <div className='head'>
                        <div className='leftHead'>
                            <img className='logoMacra' src={LogoMacRADesignNegative} alt='Maccaferri logo header' />
                            <span className='title'>
                                <h5>{t('header_title')}</h5>
                            </span>
                        </div>
                        <a className='backToHub' href={process.env.EDESIGN_PORTAL_URL}>
                            {t('header_back_to_hub')}
                        </a>
                        <img className='cursor-pointer logoMaccaferri' src={LogoMaccaferri} alt='Logo Maccaferri' onClick={this.handleGotoHome} />
                    </div>
                    <div className='error-boundary'>
                        <h1>{t('error_page_msg')}</h1>
                        <Button className='d-flex justify-content-end mb-3' onClick={this.handleGotoHome}>
                            {t('header_label_home')}
                        </Button>
                    </div>
                </header>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
